import styled from "styled-components";

// styles
import colors from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";
import {
    regular as regularFontWeight,
    medium as mediumFontWeight
} from "core/fontStyles";

export const MetaStyled = styled.div`
    display: flex;
    justify-content: flex-start;

    margin-bottom: ${convertPxToRem({ px: 24 })};
    color: ${colors.secondary.dolphin};
    ${regularFontWeight}
    line-height: 160%;
`;

export const CheckMarkStyled = styled.div`
    flex: 0 0 ${convertPxToRem({ px: 36 })};
    padding-top: 2px;

    svg {
        position: relative;
        top: ${convertPxToRem({ px: 1 })};
    }
`;

export const ReadyForDownloadStyled = styled.div`
    color: ${colors.alternative.lightMode.chartreuse};
    ${mediumFontWeight};
    margin-top: 4px;
`;
